export default {
      id: "ic_game_percent_white-usage",
      viewBox: "0 0 34 34",
      url: "/" + "images/icons.3.109.2.svg#ic_game_percent_white-usage",
      toString: function () {
        return this.url;
      }
    }